import { View } from '@/components/ui/tw-wrappers';
import { clsx } from "clsx";
import { useEffect } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withSequence,
    withTiming,
} from 'react-native-reanimated';

export function ScenarioSkeleton({ count = 3 }: { count?: number }) {
    // We show 4 placeholders to match the typical scenario count
    const items = Array.from({ length: count });

    const opacity = useSharedValue(0.3);

    useEffect(() => {
        opacity.value = withRepeat(
            withSequence(
                withTiming(0.7, { duration: 800 }),
                withTiming(0.3, { duration: 800 })
            ),
            -1,
            true
        );
    }, []);

    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacity.value,
    }));

    return (
        <View style={styles.wrap}>
            {items.map((_, i) => (
                <View key={i} className={clsx("w-full h-full", count > 1 ? "md:w-[48%] lg:w-[32%]" : undefined)}>
                    <Animated.View style={[styles.card, animatedStyle]}>
                        <View style={styles.header} />
                        <View style={styles.body} />
                        <View style={styles.footer} />
                    </Animated.View>
                </View>
            ))}
        </View>
    );
}

const styles = StyleSheet.create({
    wrap: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
        justifyContent: 'space-between',
        height: '100%',
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: 16,
        borderWidth: 1,
        borderColor: 'rgba(0,0,0,0.06)',
        padding: 20,
        gap: 16,
        minHeight: 800,
        height: '100%', // Approximate height of a real card
    },
    header: {
        height: 24,
        width: '60%',
        backgroundColor: '#f0f0f0',
        borderRadius: 4,
    },
    body: {
        flex: 1,
        backgroundColor: '#f5f5f5',
        borderRadius: 8,
    },
    footer: {
        height: 40,
        backgroundColor: '#f0f0f0',
        borderRadius: 8,
    },
});
